var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearchIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "A97408AD-1D56-4F88-B465-690CE0DA8AD8")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "141a_Admin---FSE",
    transform: "translate(-1060.000000, -492.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FAFAFA",
    x: 0,
    y: 0,
    width: 1366,
    height: 1024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(1016.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    stroke: "#EAEAEA",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 286,
    height: 39,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-&-Label",
    transform: "translate(12.000000, 8.000000)",
    fill: "#A4A4A4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic_search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.328125,12.703125 C7.20312937,13.5781294 8.26561875,14.015625 9.515625,14.015625 C10.7656313,14.015625 11.8281206,13.5781294 12.703125,12.703125 C13.5781294,11.8281206 14.015625,10.7656312 14.015625,9.515625 C14.015625,8.26561875 13.5781294,7.20312937 12.703125,6.328125 C11.8281206,5.45312063 10.7656313,5.015625 9.515625,5.015625 C8.26561875,5.015625 7.20312937,5.45312063 6.328125,6.328125 C5.45312063,7.20312937 5.015625,8.26561875 5.015625,9.515625 C5.015625,10.7656312 5.45312063,11.8281206 6.328125,12.703125 Z M15.515625,14.015625 L20.484375,18.984375 L18.984375,20.484375 L14.015625,15.515625 L14.015625,14.71875 L13.734375,14.4375 C12.5468691,15.4687552 11.1406331,15.984375 9.515625,15.984375 C7.70311594,15.984375 6.16406883,15.3593813 4.8984375,14.109375 C3.63280617,12.8593687 3,11.3281341 3,9.515625 C3,7.70311594 3.63280617,6.16406883 4.8984375,4.8984375 C6.16406883,3.63280617 7.70311594,3 9.515625,3 C11.3281341,3 12.8593688,3.63280617 14.109375,4.8984375 C15.3593813,6.16406883 15.984375,7.70311594 15.984375,9.515625 C15.984375,10.1718783 15.8281266,10.9140584 15.515625,11.7421875 C15.2031234,12.5703166 14.843752,13.2343725 14.4375,13.734375 L14.71875,14.015625 L15.515625,14.015625 Z",
    id: "s"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search_icon.858aff7b.svg";
export { ForwardRef as ReactComponent };